import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWemoComponent } from './simple-icons-wemo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWemoComponent ],
    exports:      [ SimpleIconsWemoComponent ],
    bootstrap:    []
})
export class SimpleIconsWemoModule {}
